import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$UPDATE_SERVICE;

import * as types from "@/store/constants/types";
export default (_types$UPDATE_SERVICE = {}, _defineProperty(_types$UPDATE_SERVICE, types.UPDATE_SERVICE_LIST, function (state, payLoad) {
  state.serviceList = payLoad;
}), _defineProperty(_types$UPDATE_SERVICE, types.UPDATE_USER_MSG, function (state, payLoad) {
  state.userMsg = payLoad;
}), _defineProperty(_types$UPDATE_SERVICE, types.UPDATE_RATE_US_STATUS, function (state, payLoad) {
  state.ratedUs = payLoad;
}), _defineProperty(_types$UPDATE_SERVICE, types.UPDATE_VIP_CLOSE_COUNT, function (state, payLoad) {
  state.vipCloseCount += 1;
}), _types$UPDATE_SERVICE);